import { QueryStatus } from '../../../../../types'
import {OperacionCF} from '../types/types'
import { useEffect, useState } from 'react'
import {HttpCF} from "../api/httpCF";

export const useOperacionCF = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionCF>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpCF.get(idOperacion)
            .then(data => {
                console.log('operacion', data)
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return { status, operacion }
}
